import PropTypes from "prop-types";

import moment from "moment";

import { RoleID } from "./enums";

// Strings / numbers for hours are inconsistent in this application.
const numberOrString = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string,
]);

export const AccountShape = PropTypes.shape({

});

export const RoleShape = PropTypes.shape({
  defaultWorkingHours: PropTypes.number,
  id: RoleID,
  notificationDelay: PropTypes.number,
});

export const CategoryShape = PropTypes.shape({
  allowForecasting: PropTypes.bool,
  desc: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  roles: PropTypes.arrayOf(RoleID),
});

export const DistributorShape = PropTypes.shape({

});

export const InterlockShape = PropTypes.shape({

});

export const LocationShape = PropTypes.shape({

});

export const OpportunityShape = PropTypes.shape({

});

export const ProductGroupShape = PropTypes.shape({

});

export const ProductLineShape = PropTypes.shape({

});

export const ServiceRequestShape = PropTypes.shape({

});

export const DateInstance = PropTypes.instanceOf(Date);

export const MomentInstance = PropTypes.instanceOf(moment);

// this is also inconsistent in various places
export const EntryDate = PropTypes.oneOfType([
  MomentInstance,
  PropTypes.string,
]);

const baseEntry = {
  entryDate: EntryDate.isRequired,
  actualDate: DateInstance.isRequired,
  stringDate: PropTypes.string.isRequired,
  // Equivalent to stringDate
  key: PropTypes.string.isRequired,
  submitted: PropTypes.string,
};

const sharedEntryProps = {
  account: AccountShape,
  accountId: PropTypes.string,
  // The actual category (if present) is stored on categoryObject
  category: PropTypes.string,
  categoryId: PropTypes.string,
  categoryObject: CategoryShape,
  competitiveReplacement: PropTypes.bool,
  comment: PropTypes.string,
  createDate: PropTypes.string,
  distributor: DistributorShape,
  distributorId: PropTypes.string,
  hours: numberOrString,
  interlock: InterlockShape,
  interlockId: PropTypes.string,
  location: LocationShape,
  locationId: PropTypes.string,
  lastModifiedDate: PropTypes.string,
  onsite: PropTypes.bool,
  onsiteDetail: PropTypes.string,
  opportunity: OpportunityShape,
  opportunityId: PropTypes.string,
  productGroup: ProductGroupShape,
  productGroupId: PropTypes.string,
  productLine: ProductLineShape,
  productLineId: PropTypes.string,
  serviceRequest: ServiceRequestShape,
  serviceRequestId: PropTypes.string,
  submitDate: PropTypes.string,
  userId: PropTypes.string,
};

export const EntryStateShape = PropTypes.shape({
  entryDate: EntryDate,
  ...sharedEntryProps,
  deleteProcessing: PropTypes.bool,
  submitProcessing: PropTypes.bool,
});

export const EntryShape = PropTypes.shape({
  ...baseEntry,
  ...sharedEntryProps,
});

export const NoEntryShape = PropTypes.shape({
  ...baseEntry,
  noEntries: PropTypes.bool,
});

export const AnyEntryShape = PropTypes.oneOfType([
  EntryShape,
  NoEntryShape,
]);

export const EntriesShape = PropTypes.arrayOf(EntryShape);

export const WorkDayShape = PropTypes.shape({
  enabled: PropTypes.bool,
  workingHours: numberOrString,
});

export const DayGroupShape = PropTypes.shape({
  entries: EntriesShape,
  hoursWorked: PropTypes.number,
  isWorkDay: PropTypes.bool,
  workDay: WorkDayShape,
});

export const DayGroupsShape = PropTypes.arrayOf(DayGroupShape);



// WEBPACK FOOTER //
// ./app/props/shapes.js